import { render, staticRenderFns } from "./Jacket.vue?vue&type=template&id=67ca87c8&scoped=true&"
import script from "./Jacket.vue?vue&type=script&lang=js&"
export * from "./Jacket.vue?vue&type=script&lang=js&"
import style0 from "./Jacket.vue?vue&type=style&index=0&id=67ca87c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca87c8",
  null
  
)

export default component.exports